import { Fragment, memo, useEffect } from "react";

import { Button } from "react-bootstrap";

//BoxedRouter
import BoxedFancyRouter from "../../router/boxed-fancy-router";

//header
import HeaderStyle2 from "../../components/partials/dashboard/HeaderStyle/header-style-2";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";
import Loader from "../../components/Loader";

// store
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";

const BoxedFancy = memo((props) => {
  useEffect(() => {
    document.body.classList.add("boxed-fancy");
    return () => {
      document.body.classList.remove("boxed-fancy");
    };
  });
  return (
    <Fragment>
    <div className="boxed-inner">
      <div id="loading">
        <Loader />
      </div>
      <span className="screen-darken"></span>
      <main className="main-content">
        <HeaderStyle2 />
        <div className="conatiner-fluid content-inner">
          <BoxedFancyRouter />
        </div>
        
          
        <Footer />
      </main>
    </div>
    <SettingOffCanvas/>
    </Fragment>
  );
});

export default BoxedFancy;
